<template>
  <div
  class="h-screen bg-img flex w-full vx-row no-gutter justify-center"
>
  <div class="vx-col sm:m-0 m-4">
    <div class="vx-row items-center justify-center"  style="margin-bottom:7rem"> 
        <div
          class="vx-col w-full lg:w-1/4 md:w-1/2 sm:w-1/2 mt-10" style="min-width: 200px;"
          v-for="item in this.products"
          :key="item.InvoiceSettingGroupId"  
          @click="$router.push('/paymentgroup/' + item.InvoiceSettingKey)"
        >
          <vx-card class="text-center cursor-pointer">
            <img src="https://portal.fsm.edu.tr/blank_logo.png" alt="graphic" width="100%" height="120" class="mb-6"  style="object-fit: scale-down;"/>
            <h5 class="mb-2">{{ item.ProductTitle }}</h5>
          </vx-card>
        </div> 
    </div>
  </div> 
</div>
</template>

<script>
import Vue from "vue";
import InvoiceApi from "@/api/invoice";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA });

export default {
  components: {},
  data() {
    return {
      products: []
    };
  },
  methods: {
    async fetchLoadData() {
      this.$vs.loading({
        color: "#000",
        scale: 0.45
      });

      const slug = this.$route.params.slug;

      var result = await InvoiceApi.getProducts(
        { Slug: slug.toString() },
        this
      );

      if (result.data.success)
        this.products = result.data.model;
      
      setTimeout(() => {
        this.$vs.loading.close();
      }, 100);
    }
  },
  created() {},
  mounted() {
    this.fetchLoadData();
  }
};
</script>